import script from "./ProductDetailsV2.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetailsV2.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetailsV2.vue?vue&type=style&index=0&id=60404ed1&lang=scss"

const __exports__ = script;

export default __exports__